import type { CognitoDetails } from 'mission-control-common-components/src/util/user/types';

import { getCognitoDetailsFromFlagsOrToken } from '../../utils/cognitoDetails';
import { useFeatureFlags } from '../useFeatureFlags';

export const useCognitoDetails = (): CognitoDetails => {
  const { newCognitoPoolEnabled } = useFeatureFlags();

  return getCognitoDetailsFromFlagsOrToken(newCognitoPoolEnabled);
};

export default useCognitoDetails;
